import { render, staticRenderFns } from "./ed-footer.vue?vue&type=template&id=52295a88&scoped=true&"
import script from "./ed-footer.ts?vue&type=script&lang=ts&"
export * from "./ed-footer.ts?vue&type=script&lang=ts&"
import style0 from "./ed-footer.scss?vue&type=style&index=0&id=52295a88&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52295a88",
  null
  
)

export default component.exports